import { ReactNode } from 'react';

import { cx } from '@libs/classnames';

import styles from './SegmentedControl.module.css';

export type SegmentOption<T = string> = {
  value: T;
  label: ReactNode;
  disabled?: boolean;
};

type Props<T = string> = {
  className?: string;
  value?: T;
  options: readonly SegmentOption<T>[];
  disabled?: boolean;
  onChange?: (value: T) => void;
};

export function SegmentedControl<T extends string | boolean | number>({
  className,
  value,
  options,
  disabled,
  onChange,
}: Props<T>) {
  const onSelect = (next: T) => {
    if (next !== value) {
      onChange?.(next);
    }
  };

  return (
    <div className={cx(styles.segmented_control, className)}>
      {options.map((o) => (
        <button
          key={o.value.toString()}
          type="button"
          className={cx(styles.segmented_control__button, {
            [styles.is_active]: o.value === value,
            [styles.is_disabled]: o.disabled || disabled,
          })}
          onClick={() => onSelect(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
